const initScrollHeader = () => {
  const header = document.getElementById('site-header')
  const headerNavigation = document.getElementById('header-navigation')

  if (!header) {
    return
  }

  let lastScrollY = window.scrollY
  let ticking = false
  let isHeaderElementFocused = false
  let isHeaderHovered = false
  let isTopZoneHovered = false

  const isMobile = () => window.innerWidth < 1024

  const updateHeader = () => {
    if (document.body.classList.contains('menu-open')) {
      ticking = false
      return
    }

    const currentScrollY = window.scrollY
    const isScrollingUp = currentScrollY < lastScrollY
    const isAtTop = currentScrollY <= 10

    if (isMobile()) {
      if (isHeaderElementFocused || isAtTop || isTopZoneHovered) {
        header.classList.add('header-visible')
        header.classList.remove('header-hidden')
      } else if (isScrollingUp) {
        header.classList.add('header-visible')
        header.classList.remove('header-hidden')
      } else {
        header.classList.remove('header-visible')
        header.classList.add('header-hidden')
      }
    } else {
      header.classList.add('header-visible')
      header.classList.remove('header-hidden')

      if (headerNavigation) {
        if (isHeaderElementFocused || isAtTop || isHeaderHovered) {
          headerNavigation.classList.add('section-visible')
          headerNavigation.classList.remove('section-hidden')
        } else if (isScrollingUp) {
          headerNavigation.classList.add('section-visible')
          headerNavigation.classList.remove('section-hidden')
        } else {
          headerNavigation.classList.remove('section-visible')
          headerNavigation.classList.add('section-hidden')
        }
      }
    }

    lastScrollY = currentScrollY
    ticking = false
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateHeader)
      ticking = true
    }
  })

  let resizeTimeout: number
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = window.setTimeout(() => {
      if (!ticking) {
        requestAnimationFrame(updateHeader)
        ticking = true
      }
    }, 150)
  })

  header.addEventListener('mouseenter', () => {
    if (!isMobile()) {
      isHeaderHovered = true
      if (!ticking) {
        requestAnimationFrame(updateHeader)
        ticking = true
      }
    }
  })

  header.addEventListener('mouseleave', () => {
    if (!isMobile()) {
      isHeaderHovered = false
    }
  })

  document.addEventListener('mousemove', (e: MouseEvent) => {
    if (!isMobile()) {
      return
    }

    const inTopZone = e.clientY < window.innerHeight / 4
    if (inTopZone !== isTopZoneHovered) {
      isTopZoneHovered = inTopZone
      if (inTopZone && !ticking) {
        requestAnimationFrame(updateHeader)
        ticking = true
      }
    }
  })

  document.addEventListener('focusin', (e) => {
    const target = e.target as HTMLElement
    if (header.contains(target)) {
      isHeaderElementFocused = true
      if (!ticking) {
        requestAnimationFrame(updateHeader)
        ticking = true
      }
    }
  })

  document.addEventListener('focusout', (e) => {
    const target = e.target as HTMLElement
    if (header.contains(target)) {
      isHeaderElementFocused = false
      if (!ticking) {
        requestAnimationFrame(updateHeader)
        ticking = true
      }
    }
  })

  updateHeader()
}

export default initScrollHeader()
